module.exports = __webpack_public_path__ + "media/images/menu-icons/my-progress-56eab2dd01d460d19d5e52008870fdfa.svg";